/**
 * @version 1.0
 * @author xieyq
 * @createTime 2021/12/1
 * @updateTime 2021/12/1
 * @decription 保全申请对应的请求数据
 * @namespace 【request】 请求组装
 */
import request from '@/api/axios';
export default {
    // 方法
    methods: {
        /**
         * 获取保全审核信息
         * @param {String} bqid 保全id
         * @returns {Promise} promise对象
         * */
        requestShxx(bqid){
            return new Promise((resolve, reject) => {
                request({
                    url: 'ssbq/api/sqbq/shxx',
                    method: 'get',
                    params:{
                        time: new Date().getTime(),
                        // 保全id
                        bqid: bqid
                    },
                }).then(res => {
                    resolve(res.data);
                })
                    .catch(e => {
                        reject(e);
                    });
            });
        }
    }
};
